import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetDashboardData, GetEmployeeDashboardData } from "helpers/api_method";

export const getDashboardCounts = createAsyncThunk("dashboard/getDashboardCounts", async (_, { rejectWithValue }) => {
    try {
        const response = await GetDashboardData();
        
        // Handle different response structures
        if (response && response.data) {
            // If response has data property, return it
            return response.data;
        } else if (response && typeof response === 'object' && 'data' in response) {
            // If response is an object with data property
            return response.data;
        } else if (response && typeof response === 'object') {
            // If response is a plain object (direct data)
            return response;
        } else {
            return rejectWithValue('Failed to fetch dashboard data');
        }
    } catch (error: any) {
        console.error('Dashboard fetch error:', error);
        // Our axios interceptor may reject with a string message.
        if (typeof error === 'string') {
            return rejectWithValue(error);
        }
        return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch dashboard data');
    }
});

export const getEmpDashboardCounts = createAsyncThunk("dashboard/getEmpDashboardCounts", async (_, { rejectWithValue }) => {
    try {
        const response = await GetEmployeeDashboardData();
        
        // Handle different response structures
        if (response && response.data) {
            // If response has data property, return it
            return response.data;
        } else if (response && typeof response === 'object' && 'data' in response) {
            // If response is an object with data property
            return response.data;
        } else if (response && typeof response === 'object') {
            // If response is a plain object (direct data)
            return response;
        } else {
            return rejectWithValue('Failed to fetch employee dashboard data');
        }
    } catch (error: any) {
        console.error('Employee dashboard fetch error:', error);
        if (typeof error === 'string') {
            return rejectWithValue(error);
        }
        return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch employee dashboard data');
    }
});